module.exports = __webpack_public_path__ + "img/bar-chart.8532679b.gif";